import { render, staticRenderFns } from "./prediction-organization-side-action.vue?vue&type=template&id=a7062716"
import script from "./prediction-organization-side-action.ts?vue&type=script&lang=js&external"
export * from "./prediction-organization-side-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports